(() => {
  const roots = new WeakMap();
  const init = scope => scope.querySelectorAll('[data-laagam-story]').forEach(root => {
    if (roots.has(root)) return;
    const abort = new AbortController();
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const cleanups = [];
    root.querySelectorAll('[data-laagam-scenes]').forEach(scene => {
      const tabs = [...scene.querySelectorAll('[data-laagam-tab]')];
      const panels = [...scene.querySelectorAll('[data-laagam-panel]')];
      const frame = scene.querySelector('.l-scenes');
      let active = panels[0], timer;
      const updateHeight = () => { if (active) frame.style.height = `${active.getBoundingClientRect().height}px`; };
      const show = (key, animate = true) => {
        const next = panels.find(panel => panel.dataset.laagamPanel === key);
        if (!next || (active === next && scene.hasAttribute('data-scenes-ready'))) return;
        if (animate) frame.style.height = `${frame.getBoundingClientRect().height}px`;
        panels.forEach(panel => {
          panel.hidden = panel !== next;
          panel.inert = panel !== next;
          if (panel !== next) panel.querySelectorAll('video').forEach(video => video.pause());
          panel.classList.remove('is-entering');
        });
        active = next;
        tabs.forEach(tab => { const selected = tab.dataset.laagamTab === key; tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1; });
        if (animate && !motion.matches) next.classList.add('is-entering');
        requestAnimationFrame(updateHeight);
        clearTimeout(timer); timer = setTimeout(() => next.classList.remove('is-entering'), 450);
      };
      scene.querySelector('.l-tabs').addEventListener('click', event => { const tab = event.target.closest('[data-laagam-tab]'); if (tab) show(tab.dataset.laagamTab); }, {signal:abort.signal});
      scene.querySelector('.l-tabs').addEventListener('keydown', event => {
        if (!['ArrowRight','ArrowLeft','Home','End'].includes(event.key) || !tabs.includes(event.target)) return;
        event.preventDefault(); let i = tabs.indexOf(event.target);
        i = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[i].focus({preventScroll:true}); show(tabs[i].dataset.laagamTab);
      }, {signal:abort.signal});
      show(tabs[0].dataset.laagamTab, false); scene.setAttribute('data-scenes-ready','');
      const observer = new ResizeObserver(updateHeight); panels.forEach(panel => observer.observe(panel));
      cleanups.push(() => {observer.disconnect(); clearTimeout(timer);});
    });
    if ('IntersectionObserver' in window && !motion.matches) {
      const reveals = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); reveals.unobserve(entry.target); }
      }), {threshold:.18});
      root.querySelectorAll('[data-laagam-reveal]').forEach(element => { element.setAttribute('data-reveal-ready',''); reveals.observe(element); });
      cleanups.push(() => reveals.disconnect());
    }
    roots.set(root, () => {abort.abort(); cleanups.forEach(cleanup => cleanup());});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true}); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-laagam-story]').forEach(root => {roots.get(root)?.(); roots.delete(root);}));
})();
